export const APPROVAL_STATE = {
  cecbRequireExpertApproval: 'CECB_REQUIRE_EXPERT_APPROVAL',
  cecbAwaitingExpertApproval: 'CECB_AWAITING_EXPERT_APPROVAL',
  expertShouldApproveAssessment: 'EXPERT_SHOULD_APPROVE_ASSESSMENT',
  expertHasApprovedAssessment: 'EXPERT_HAS_APPROVED_ASSESSMENT',
  assessmentCanBeValidated: 'CAN_BE_VALIDATED',
  assessmentValidated: 'ASSESSMENT_VALIDATED',
} as const;
export type ApprovalState = typeof APPROVAL_STATE[keyof typeof APPROVAL_STATE];
